module.exports = __webpack_public_path__ + "static/HTH0-b2e5997e4b474dff46a160c4dce70a84.jpg";